import { ONEPARK_COLOR } from 'constants/App';

export default {
  palette: {
    background: {
      default: '#F8F9Fa',
    },
    primary: {
      main: ONEPARK_COLOR,
      contrastText: '#FFF',
    },
    secondary: {
      main: '#008080',
      contrastText: '#FFF',
    },
    error: {
      main: '#FF570C',
    },
    text: {
      primary: '#262626',
      secondary: 'rgba(61, 61, 61, 0.85)', // OP grey = #616161
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          color: '#262626',
        },
        header: {
          background: '#FFF',
        },
        footer: {
          width: '100%',
          marginTop: '25px',
          borderTop: '1px solid rgba(0, 0, 0, .05)',
          fontSize: '11px',
          lineHeight: '17px',
          color: '#636c72',
        },
      },
    },
    MuiTab: {
      root: {
        backgroundColor: ONEPARK_COLOR,
        '&:hover': {
          opacity: 0.9,
        },
      },
      textColorInherit: {
        color: '#FFF',
      },
    },
    MuiTabScrollButton: {
      root: {
        backgroundColor: ONEPARK_COLOR,
        color: '#FFF',
        '&$disabled': {
          opacity: 0.8,
          color: ONEPARK_COLOR,
        },
      },
    },
    MuiTableRow: {
      root: {
        '&$selected': {
          backgroundColor: 'rgba(225, 245, 251, 0.85)',
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: '0.750rem',
        fontWeight: 400,
        backgroundColor: 'rgb(97, 97, 97)',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./containers/themes/opac.js